// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GeKQt","title":"Header_title__39DG2","left":"Header_left__1sTED","clinicName":"Header_clinicName__2rblV"};